import { call, put, takeEvery } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import { FormPackType } from '@upstart/harmony/lib/constants';
import {
  formPacksSuccess,
  formPacksFailure,
  formPackSuccess,
  formPackFailure,
  createFormPackSuccess,
  createFormPackFailure,
  updateFormPackSuccess,
  updateFormPackFailure,
  deleteFormPackSuccess,
  deleteFormPackFailure,
} from './actions';
import {
  FORMPACKS_REQUEST,
  FORMPACK_REQUEST,
  CREATE_FORMPACK_REQUEST,
  UPDATE_FORMPACK_REQUEST,
  DELETE_FORMPACK_REQUEST,
} from './actionTypes';
import FormPackService from '../../services/FormPackService';

export function* getFormPacksTask(action) {
  const params = action.payload;
  try {
    const list = yield call(FormPackService.getFormPacks, params);
    yield put(formPacksSuccess(list));
  } catch (error) {
    yield put(formPacksFailure(error));
  }
}

export function* getFormPackTask(action) {
  try {
    const formId = action.payload;
    const form = yield call(FormPackService.getFormPack, formId);
    yield put(formPackSuccess(form));
  } catch (error) {
    yield put(formPackFailure(error));
  }
}

export function* createFormPackTask(action) {
  try {
    const params = action.payload;
    const form = yield call(FormPackService.createFormPack, params);
    yield put(createFormPackSuccess(form));
    yield put(replace(`/${params.dealer_id}/formPacks`));
  } catch (error) {
    yield put(createFormPackFailure(error));
  }
}

export function* updateFormPackTask(action) {
  try {
    const params = action.payload;
    const form = yield call(FormPackService.updateFormPack, params);
    yield put(updateFormPackSuccess(form));

    // Depending on what pack was updated go to a different path
    const finishPath =
      params.type === FormPackType.ONLINE
        ? `/${params.dealer_id}/onlineFormPacks`
        : `/${params.dealer_id}/formPacks`;
    yield put(replace(finishPath));
  } catch (error) {
    yield put(updateFormPackFailure(error));
  }
}

export function* deleteFormPackTask(action) {
  try {
    const formId = action.payload;
    yield call(FormPackService.deleteFormPack, formId);
    yield put(deleteFormPackSuccess(formId));
  } catch (error) {
    yield put(deleteFormPackFailure(error));
  }
}

export function* formPacksSaga() {
  yield takeEvery(FORMPACKS_REQUEST, getFormPacksTask);
  yield takeEvery(FORMPACK_REQUEST, getFormPackTask);
  yield takeEvery(CREATE_FORMPACK_REQUEST, createFormPackTask);
  yield takeEvery(UPDATE_FORMPACK_REQUEST, updateFormPackTask);
  yield takeEvery(DELETE_FORMPACK_REQUEST, deleteFormPackTask);
}
